/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import {Input, InputAdornment, InputLabel} from '@material-ui/core';
import {FormControl} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Helper from "../../Utils";

const styles = theme => ({
});

class Password extends React.Component {
    state = {
        password: '',
        showPassword: false,
    };

    handleChangePassword = event => {
        this.setState({password: event.target.value});
        if(this.props.valueCallback != null){
            this.props.valueCallback(event.target.value);
        }
    };

    handleMouseDownPassword = event => {
        event.preventDefault();
    };

    handleClickShowPasssword = () => {
        this.setState({showPassword: !this.state.showPassword});
    };

    render() {
        const {classes} = this.props;

        return (
            <FormControl className={this.props.className} fullWidth={this.props.fullWidth} error={this.props.error}>
                <InputLabel htmlFor="password">{this.props.label === undefined ? "Password" : this.props.label}</InputLabel>
                <Input fullWidth
                       id="password"
                       type={this.state.showPassword ? 'text' : 'password'}
                       value={this.state.password}
                       placeholder={this.props.placeholder}
                       onChange={this.handleChangePassword}
                       onKeyDown={Helper.enterPressed(this.props.onEnter)}
                       endAdornment={
                           <InputAdornment position="end">
                               <IconButton
                                   onClick={this.handleClickShowPasssword}
                                   onMouseDown={this.handleMouseDownPassword}
                               >
                                   {this.state.showPassword ? <VisibilityOff/> : <Visibility/>}
                               </IconButton>
                           </InputAdornment>
                       }
                />
            </FormControl>
        );
    }
}

Password.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Password);